import {PaperclipIcon} from '@primer/octicons-react'
import {ActionBar, type IconButtonProps} from '@primer/react'

export function FileUploadButton(props: Omit<IconButtonProps, 'icon' | 'aria-label' | 'variant' | 'aria-labelledby'>) {
  return (
    <ActionBar.IconButton
      // Prevent focus leaving input:
      onMouseDown={e => e.preventDefault()}
      variant="invisible"
      icon={PaperclipIcon}
      aria-label="Attachment"
      {...props}
    />
  )
}

try{ FileUploadButton.displayName ||= 'FileUploadButton' } catch {}